import React from "react";
import { TextField } from "@mui/material";

const ClientName = ({
  clientName,
  handleClientNameChange,
  loading,
  errors,
}) => {
  return (
    <TextField
      label="Client Name"
      name="clientName"
      value={clientName}
      onChange={(e) => handleClientNameChange(e.target.value)} // Bind state to the input value
      fullWidth
      required
      size="small"
      disabled={loading}
      error={!!errors.name}
      helperText={errors.name}
    />
  );
};

export default ClientName;
